import { render, staticRenderFns } from "./KnowledgeBaseSync.vue?vue&type=template&id=5c1835cb&scoped=true&"
import script from "./KnowledgeBaseSync.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseSync.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseSync.vue?vue&type=style&index=0&id=5c1835cb&scoped=true&lang=css&"
import style1 from "@/assets/wap/cloud-mobile.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1835cb",
  null
  
)

export default component.exports